import { render, staticRenderFns } from "./UiLogo.vue?vue&type=template&id=50a5b529&scoped=true"
import script from "./UiLogo.vue?vue&type=script&lang=js"
export * from "./UiLogo.vue?vue&type=script&lang=js"
import style0 from "./UiLogo.vue?vue&type=style&index=0&id=50a5b529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5b529",
  null
  
)

export default component.exports